import { RDAmendmentSummary } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const AmendmentSummaryCellDisplayValue = ({ value }: { value: any }) => {
  const { t } = useTranslation('@cibo/landmanager/AmendmentSummary')
  if (!value) return null

  const { input } = value

  return !!input ? (
    <Stack>
      <Typography variant="body2">
        {input.applicationType === 'not_available'
          ? t('n/a')
          : t('cellDisplayRate', {
              rate: input.rate,
              applicationType: t(`applicationType_${input.applicationType}`),
              units: t(`units_${input.units}`),
            })}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {[
          !!input.compost && t('compost'),
          !!input.manure && t('manure'),
          !!input.biochar && t('biochar'),
        ]
          .filter(Boolean)
          .join(', ')}
      </Typography>
    </Stack>
  ) : (
    <>{t('none')}</>
  )
}

export const AmendmentSummaryCellDisplay = ({
  params: { row },
  year,
  traitId,
}: TraitCellDisplayProps<RDAmendmentSummary>) => {
  const amendmentSummary = row.findDetail<RDAmendmentSummary>({ traitId, year })
  if (!amendmentSummary) return <></>
  return <AmendmentSummaryCellDisplayValue value={amendmentSummary} />
}
